import colors from '../../../../theme/foundations/colors'
import {fonts} from '../../../../theme/foundations/fonts'
import {pxToRem} from '../../../../utills/pxToRem'

export const iconStyle = {
    width: [pxToRem(73), pxToRem(73), pxToRem(110.45), pxToRem(110.45)],
    height: [pxToRem(54), pxToRem(54), pxToRem(82), pxToRem(82)]
}

export const emptyCartTitle = {
    marginTop: [pxToRem(20), pxToRem(20), pxToRem(29.19), pxToRem(29.19)],
    marginLeft: 'auto',
    marginRight: 'auto',
    width: [pxToRem(298), pxToRem(298), 'auto', 'auto'],
    marginBottom: '0px',
    color: 'black',
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(22), pxToRem(22), pxToRem(30), pxToRem(30)],
    fontWeight: '600',
    lineHeight: 'normal',
    letterSpacing: [pxToRem(3), pxToRem(3), pxToRem(4), pxToRem(4)],
    textTransform: 'uppercase'
}

export const descriptionMessageStyle = {
    marginTop: [
        `${pxToRem(20)} !important`,
        `${pxToRem(20)} !important`,
        `${pxToRem(35)} !important`,
        `${pxToRem(35)} !important`
    ],
    width: ['auto', 'auto', pxToRem(608), pxToRem(608)],
    color: 'black',
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1)
}

export const shoppingButtonStyle = {
    backgroundColor: 'white',
    border: `${pxToRem(1)} solid ${colors.cav_red}`,
    color: 'cav_red',
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(14), pxToRem(14)],
    fontWeight: '700',
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textTransform: 'uppercase',
    height: [pxToRem(35), pxToRem(35), pxToRem(40), pxToRem(40)],
    width: ['100%', '100%', pxToRem(295), pxToRem(295)],
    padding: `${pxToRem(12)} ${pxToRem(20)}`,
    borderRadius: '0px',
    '&:hover': {
        borderRadius: '0px',
        backgroundColor: 'cav_red',
        color: 'white',
        textDecoration: 'none'
    }
}

export const signinButtonStyle = {
    background: 'cav_red !important',
    color: 'white !important',
    textAlign: 'center',
    borderRadius: '0px',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(14), pxToRem(14)],
    fontWeight: '700',
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textTransform: 'uppercase',
    height: [pxToRem(35), pxToRem(35), pxToRem(40), pxToRem(40)],
    width: ['100%', '100%', pxToRem(295), pxToRem(295)],
    padding: `${pxToRem(12)} ${pxToRem(20)}`,
    '&:hover': {
        border: `${pxToRem(1)} solid ${colors.cav_red}`,
        borderRadius: '0px',
        textDecoration: 'none',
        backgroundColor: 'white !important',
        color: 'cav_red !important'
    }
}

export const recommendedProductStyle = {
    marginTop: [pxToRem(60), pxToRem(60), pxToRem(80), pxToRem(80)]
}
